import { useTranslation } from 'react-i18next'

export type CancellationReasonType =
  | 'BUYER_CHANGED_MIND'
  | 'BUYER_FOUND_BETTER_PRICE'
  | 'DEALER_OUT_OF_STOCK'
  | 'DEALER_CANNOT_FULFILL'
  | 'PAYMENT_FAILED'
  | 'PAYMENT_EXPIRED'
  | 'SYSTEM_ERROR'
  | 'ADMIN_FORCE_CANCEL'

export function useCancellationReasonLabels(): Record<CancellationReasonType, string> {
  const { t } = useTranslation()

  return {
    BUYER_CHANGED_MIND: t('common.cancellationReasons.BUYER_CHANGED_MIND'),
    BUYER_FOUND_BETTER_PRICE: t('common.cancellationReasons.BUYER_FOUND_BETTER_PRICE'),
    DEALER_OUT_OF_STOCK: t('common.cancellationReasons.DEALER_OUT_OF_STOCK'),
    DEALER_CANNOT_FULFILL: t('common.cancellationReasons.DEALER_CANNOT_FULFILL'),
    PAYMENT_FAILED: t('common.cancellationReasons.PAYMENT_FAILED'),
    PAYMENT_EXPIRED: t('common.cancellationReasons.PAYMENT_EXPIRED'),
    SYSTEM_ERROR: t('common.cancellationReasons.SYSTEM_ERROR'),
    ADMIN_FORCE_CANCEL: t('common.cancellationReasons.ADMIN_FORCE_CANCEL'),
  }
}
